const { default: Swal } = require("sweetalert2");

export const hasEmpty = (lang, values, names, code) => {
  let hasEmpties = false;
  let text = "";
  values.map((value, index) => {
    if (value.trim() === "") {
      hasEmpties = true;
      text +=
        names[index] + " can not be empty<br />" + code ? `(${code})` : "";
    }
  });
  if (hasEmpties) {
    Swal.fire({
      title: "Warning",
      html: text,
      icon: "error",
    });
  }
  return hasEmpties;
};

export const displaySuccessMessage = (lang, message, code) => {
  //
  Swal.fire({
    // title: "Warning",
    html: code ? message + `(${code})` : message,
    icon: "success",
    showConfirmButton: false,
    timer: 2000,
  });
};
export const displayErrorMessage = (lang, message, code) => {
  //
  Swal.fire({
    // title: "Warning",
    html: message
      ? message + (code ? `(${code})` : "")
      : "هنگام اجرای دستورات خطایی رخ داد. لطفاً بعداً دوباره امتحان کنید" +
        (code ? `(${code})` : ""),
    icon: "error",
  });
};
